import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ component: Component }) => {
  const location = useLocation();
  const releaseProtection = location?.state?.releaseProtection || false;

  return releaseProtection ? <Component /> : <Navigate to="/404" />;
};

export default ProtectedRoute;
